module.exports = __webpack_public_path__ + "static/img/tip.5c8cdd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tip.png
// module id = Wqg/
// module chunks = 1